import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { PLAID_LINK_CDN as filePath, PLAID_LINK_CDN_REMOVE as stringForRemoveLink } from 'apps/auth/constants/UrlConstants';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { removeLink, removeScript } from 'apps/auth/helpers/DOM';

const SendByPlaid = (props) => {
    const handler = useRef(null);

    useEffect(() => {
        let script = document.createElement('script');
        script.src = filePath;
        script.type = 'text/javascript';
        document.head.append(script);
        script.onload = function () {
            if (props.extra?.linkToken && Plaid) {
                handler.current = Plaid.create({
                    token: props.extra?.linkToken,
                    onSuccess: function (public_token, metadata) {
                        logInfo('onSuccess');
                        logInfo('public_token:', public_token);
                        logInfo('metadata: ', metadata);
                        props.onSuccess(metadata, public_token);
                    },
                    onExit: function (err, metadata) {
                        props.toggleModal(false);
                        logInfo('onExit');
                        logInfo('err:', err);
                        logInfo('metadata:', metadata);
                    },
                    onEvent: function (eventName, metadata) {
                        logInfo('onEvent');
                        logInfo('eventName:', eventName);
                        logInfo('metadata:', metadata);
                    },
                });
                handler.current.open();
            }
        };
        return () => {
            if (handler.current) {
                removeScript(filePath);
                removeLink(stringForRemoveLink);
                handler.current.destroy();
            }
        };
    }, [props.extra?.linkToken]);

    return <div />;
};
const mapStateToProps = (state) => {
    return {
        extra: state.extra,
    };
};
export default connect(mapStateToProps, { toggleModal })(SendByPlaid);
